<script setup lang="ts">
  import { computed } from 'vue';
  import { CalendarSize } from './Calendar.types';
  import { DAY_NAMES } from './utils/constants';
  import { Typo, TypoVariant } from '@/components';

  interface CalendarWeekProps {
    size?: `${CalendarSize}`;
  }

  const props = withDefaults(defineProps<CalendarWeekProps>(), {
    size: CalendarSize.M,
  });

  const textVariant = computed(() =>
    props.size === CalendarSize.M ? TypoVariant.BodyMRegular : TypoVariant.BodyLRegular,
  );
</script>

<template>
  <div :class="['tl-calendar-week', `tl-calendar-week_size-${size}`]">
    <div v-for="(day, idx) in DAY_NAMES" :key="idx" class="tl-calendar-week__day">
      <Typo :variant="textVariant">{{ day }}</Typo>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .tl-calendar-week {
    $root: &;

    align-items: center;
    display: grid;
    grid-template-columns: repeat(7, 44px);
    justify-content: center;
    width: 100%;

    &_size-l {
      grid-template-columns: repeat(7, 56px);

      #{$root}__day {
        height: 52px;
        width: 52px;
      }
    }

    &__day {
      align-items: center;
      color: var(--color-text-secondary);
      display: flex;
      height: 40px;
      justify-content: center;
      width: 40px;

      &:nth-last-child(-n + 2) {
        color: var(--color-rose-40);
      }
    }
  }
</style>
